import React from 'react';
import PropTypes from 'prop-types';
import './main.less';

class Top extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return (<nav className="main-menu__top">
			{this.props.children}
		</nav>);
	}
}

Top.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	])
};

export default Top;




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/sidebar/components/top/main.js